import { usePageEvent } from '../../../hooks';
import { WorkspacesPageBody } from './WorkspacesPageBody';
import {
  type WorkspacesPageContextProps,
  WorkspacesPageProvider,
} from './WorkspacesPageContext';

export const WorkspacesPage = ({
  navigateToWorkspace,
  getWorkspaceLink,
  organizationId,
}: WorkspacesPageContextProps) => {
  usePageEvent();

  return (
    <WorkspacesPageProvider
      navigateToWorkspace={navigateToWorkspace}
      getWorkspaceLink={getWorkspaceLink}
      organizationId={organizationId}
    >
      <WorkspacesPageBody />
    </WorkspacesPageProvider>
  );
};
